module.exports = __webpack_public_path__ + "static/media/appleStoreIcon.1c8f9adb.svg";